module.exports = __webpack_public_path__ + "static/media/8.question_loop.bdd4591c.mp4";